import { render, staticRenderFns } from "./Swatch.vue?vue&type=template&id=48ff1a9e&"
import script from "./Swatch.vue?vue&type=script&lang=js&"
export * from "./Swatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Swatch.vue"
export default component.exports